import { isValidSearchDate, SEARCH_INPUT_LIMITS, type SearchFilters } from '@agentwiki/shared'
import type { SearchSource, SearchType } from '../../hooks/use-search'
import { getWebFeatureProfile } from '../../lib/feature-flags'

const ALL_SOURCE_OPTIONS: Array<{ value: SearchSource; label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'docs', label: 'Documents' },
  { value: 'storage', label: 'Files' },
]

export function getSourceOptions(storageEnabled = getWebFeatureProfile().storageSpace) {
  return storageEnabled
    ? ALL_SOURCE_OPTIONS
    : ALL_SOURCE_OPTIONS.filter((option) => option.value === 'docs')
}

export const TYPE_OPTIONS: Array<{ value: SearchType; label: string }> = [
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'keyword', label: 'Keyword' },
  { value: 'semantic', label: 'Semantic' },
]

export function readSource(value: string | null): SearchSource {
  if (!getWebFeatureProfile().storageSpace) return 'docs'
  return value === 'docs' || value === 'storage' || value === 'all' ? value : 'all'
}

export function readType(value: string | null): SearchType {
  return value === 'hybrid' || value === 'keyword' || value === 'semantic' ? value : 'hybrid'
}

export function readSearchQuery(value: string | null) {
  const query = value?.trim() ?? ''
  return query.length <= SEARCH_INPUT_LIMITS.query ? query : ''
}

export function filtersFromParams(params: URLSearchParams): SearchFilters {
  const category = params.get('category')?.trim()
  const dateFrom = params.get('dateFrom') ?? undefined
  const dateTo = params.get('dateTo') ?? undefined
  return {
    category: category && category.length <= SEARCH_INPUT_LIMITS.category ? category : undefined,
    tags: params
      .getAll('tag')
      .map((tag) => tag.trim())
      .filter((tag) => tag.length > 0 && tag.length <= SEARCH_INPUT_LIMITS.tag)
      .slice(0, SEARCH_INPUT_LIMITS.tags),
    dateFrom: dateFrom && isValidSearchDate(dateFrom) ? dateFrom : undefined,
    dateTo: dateTo && isValidSearchDate(dateTo) ? dateTo : undefined,
  }
}
